import { environment } from './../../../environments/environment';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { Lightbox } from 'angular2-lightbox';

@Component({
  selector: 'app-single-local',
  templateUrl: './single-local.component.html',
  styleUrls: ['./single-local.component.css']
})
export class SingleLocalComponent implements OnInit {
  base_url;
  base_images;
  base_return_url = '';

  local;

  dateOffre = '';
  priceVente = '';
  priceLocation = '';
  titreFiche = '';

  _album = [];

  constructor(private _router: ActivatedRoute, private _lightbox: Lightbox, private router : Router) {
    this.base_url = environment.base_url;
    this.base_images = environment.base_url_image_locaux;

    this.base_return_url = environment.base_url +'/locaux-et-terrains/#/locaux';

    // Si on vient de la page de recherche alors on modifie le lien de retour & on reset 
    if(localStorage.getItem('click_from_search') != undefined && localStorage.getItem('click_from_search') != '') {
      this.base_return_url = localStorage.getItem('click_from_search');

      // Reset
      localStorage.setItem('click_from_search', '');
    }

    this._router.data
      .subscribe((data: { local: any }) => {
        this.local = data.local;

        var split = this.local.date_offre.split('-');

        this.dateOffre = split[2]+'/'+split[1]+'/'+split[0];
        
        // manipulate price
        this.priceVente = this.local.prix_vente.replace("HT Hors Frais","");
        this.priceLocation = this.local.prix_location.replace("HT Hors Charges","");

        // define title
        if((this.local.louer == 1 || this.local.louer == true) && (this.local.vendre == 1 || this.local.vendre == true)){
          this.titreFiche = "Disponible à la location et à la vente";
        }else if(this.local.louer == 1 || this.local.louer == true){
          this.titreFiche = "Disponible à la location";
        }else if(this.local.vendre == 1 || this.local.vendre == true){
          this.titreFiche = "Disponible à la vente";
        }
        
      });

    
  }

  ngOnInit() {
    var elements = document.getElementsByClassName('annuaire-eco-entreprise-breadcrump');


    if (elements.length != 0) {
      elements[0].scrollIntoView();
    }
  
    for (var i = 0; i < this.local.images.length; i++) {
      console.log('loop');
      this._album.push({
        src: this.base_images+this.local.images[i].chemin,
        caption: this.local.reference,
        thumb: this.base_images +this.local.images[i].chemin
      });
    }

    console.log('album', this._album);
  }

  openFancy(index: number): void {
    // open lightbox
    this._lightbox.open(this._album, index);
  }


}



// WEBPACK FOOTER //
// ./src/app/locaux/single-local/single-local.component.ts